import { createElement } from "react";
import { pdf } from "@react-pdf/renderer";
import ActaEntregaPDF from "./ActaEntregaPDF";
import { construirDatosActa, nombreArchivoActa } from "./actaData";

// Genera el PDF del acta y lo descarga en el navegador.
export const descargarActaPDF = async (acta, lineas, extras = {}) => {
  const data = construirDatosActa(acta, lineas, extras);
  const blob = await pdf(createElement(ActaEntregaPDF, { data })).toBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombreArchivoActa(acta);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
